import React from 'react'
import { SelectBox } from 'src/helper/dynamicInputGenerator'

const DynamicInputs = ({ input, option, onChange, index }) => {
  const onValueChange = (data) => {
    let newInputs = [...option?.inputs]
    newInputs[index] = data
    let newOption = { ...option, inputs: newInputs }

    onChange(newOption)
  }

  return (
    <>{input?.inputType === 'select' && <SelectBox input={input} onChange={onValueChange} />}</>
  )
}

export default DynamicInputs
